const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  batchCreate ({ state, commit, rootState }, params) {
    return rootState.axios.post('/opensearch/v1frontend/aos-analytics/batch-create', params, {
      noInterceptorError: true,
      noShowError: true,
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
